import { render } from "./ManageEvent.vue?vue&type=template&id=3d58718a"
import script from "./ManageEvent.vue?vue&type=script&lang=js"
export * from "./ManageEvent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__